import React from "react"
import Button from "@material-ui/core/Button"
import clsx from "clsx"
import { useMediaQuery } from "@material-ui/core"
import { CountDown } from "../CountDown"
import * as styles from "./rightSection.module.scss"
import { handleClickHeader } from "../../../../helpers/WatcherDL/utils/handleClickHeader"
import { RightSectionProps } from "../types"
import { GiftIcon, HintIcon } from "./icons"
import { ItemTooltipAb } from "../../../ItemTooltip/ItemTooltipAb"
import { DLClickEventExtended } from "../../../../helpers/WatcherDL/DLEvents"
import scrollToPersonalForm from "../../../../helpers/scrollToPersonalForm"

const DEFAULT_HINT_TITLE = (
  <>
    Халва.Десятка <br /> в подарок
  </>
)

const DEFAULT_HINT = (
  <>
    Оформите карту «Халва» сейчас и&nbsp;получите подписку «Халва.Десятка» в&nbsp;подарок. Раскройте
    все возможности Халвы по максимуму!
  </>
)

export const RightSection: React.FC<RightSectionProps> = ({
  isHint = false,
  countDownTime,
  buttonText,
  hint = DEFAULT_HINT,
  hintTitle = DEFAULT_HINT_TITLE,
  background,
  isCountdown = false,
  isCta = false,
}) => {
  const isMobile = useMediaQuery("(max-width:599.5px)")

  const handleButtonClick = () => {
    handleClickHeader("sticky", "header")
  }

  const renderHintSection = () => (
    <div className={styles.containerTooltip}>
      <ItemTooltipAb hintText={hint} leftPosition="-100px" icon={HintIcon}>
        {isMobile ? <GiftIcon /> : hintTitle}
      </ItemTooltipAb>
    </div>
  )

  const renderCountdown = () => (
    <button
      className={styles.notBtn}
      type="button"
      onClick={() => {
        DLClickEventExtended({
          eventAction: "Халва.Десятка в подарок",
          name: "Tooltip",
          placement: "header",
        })
        scrollToPersonalForm()
      }}
    >
      <CountDown
        nameCountDown="countDownDateHeader"
        backgroundColor="gray"
        countDownTime={countDownTime}
      />
    </button>
  )

  return (
    <div className={clsx(styles.container)}>
      {isCountdown && renderCountdown()}
      {isHint && renderHintSection()}
      {isCta && !isMobile && (
        <Button style={{ background }} classes={{ root: styles.btn }} onClick={handleButtonClick}>
          {buttonText}
        </Button>
      )}
    </div>
  )
}
